import { useHistory } from 'react-router-dom';
import { isIOS, isMobile, isTablet } from 'react-device-detect';
import Store from 'store';
import { BannerBox, BoxInImage } from '../HomePage';
import { useHomePageContext } from '../../context/HomePageContext';
import { getCurrentLang } from '../../libs/lang';
import { S3_URL } from '../../libs/common';

const isMobileView = isMobile && !(isIOS && isTablet);

export const HomeBanner2 = () => {
  const history = useHistory();
  const { state } = useHomePageContext();

  const goBannerUrl = (url, event) => {
    const urlRegex = /^(http|https):\/\//;
    if (event !== null) {
      history.push(`/events/view/${event}`);
    } else {
      if (urlRegex.test(url)) {
        window.open(url, '_blank');
      } else {
        history.push(url);
      }
    }
  };

  // 언어별 매핑
  const homeBannerMap = {
    kr: state.data.homeBannerListKo,
    en: state.data.homeBannerListEn,
    jp: state.data.homeBannerListJp,
  };

  const lang = getCurrentLang();
  const bannerList = homeBannerMap[lang] || [];

  // home_2 배너 찾기
  const targetBanner = bannerList.find((x) => x.banner_type === 'home_2');
  if (!targetBanner) return null;

  const bannerImage = isMobileView ? targetBanner.banner_mob_img : targetBanner.banner_img;

  return (
    <BannerBox
      style={{
        marginTop: '5vw',
        position: 'relative',
        cursor: 'pointer',
        marginLeft: '10px',
        marginRight: '10px',
        backgroundSize: 'contain',
        backgroundRepeat: 'no-repeat',
      }}
      onClick={() => goBannerUrl(targetBanner.banner_url, targetBanner.banner_event_id)}
    >
      <BoxInImage
        style={{
          backgroundImage: `url(${S3_URL(bannerImage)})`,
        }}
      />
    </BannerBox>
  );
};

export default HomeBanner2;
